import { Injectable } from '@angular/core';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { NewRelicService } from 'src/lib/tcs-new-relic/new-relic-initializer.service';
import { TcsConfigurationService } from 'src/app/core/configuration.service';
import { Logger, LoggerOptions, LoggerOptionsService } from './logger';

@Injectable()
export class NewRelicLogger implements Logger {
  constructor(
    private _optionsManager: LoggerOptionsService,
    private _newRelicService: NewRelicService,
    private _config: TcsConfigurationService,
  ) {}

  public error(
    error: Error | string,
    properties?: { [name: string]: string },
    options?: LoggerOptions,
  ): void {
    if (this._optionsManager.canLogToNewRelic(options)) {
      const e = error instanceof Error ? error : new Error(error);
      this._newRelicService.newRelic?.noticeError(e, {
        ...properties,
        severityLevel: SeverityLevel.Error,
        level: 'Error',
        appSpace: 'FirstCall.Tcs',
        environment: this._config.environmentDisplay,
      });
    }
  }

  public warning(
    message: string,
    properties?: { [name: string]: string },
    options?: LoggerOptions,
  ): void {
    if (this._optionsManager.canLogToNewRelic(options)) {
      this._newRelicService.newRelic?.noticeError(message, {
        ...properties,
        severityLevel: SeverityLevel.Warning,
        level: 'Warning',
        appSpace: 'FirstCall.Tcs',
        environment: this._config.environmentDisplay,
      });
    }
  }

  public info(
    message: string,
    properties?: { [name: string]: string },
    options?: LoggerOptions,
  ): void {
    if (this._optionsManager.canLogToNewRelic(options)) {
      this._newRelicService.newRelic?.noticeError(message, {
        ...properties,
        severityLevel: SeverityLevel.Information,
        level: 'Information',
        appSpace: 'FirstCall.Tcs',
        environment: this._config.environmentDisplay,
      });
    }
  }
}
